<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Situazione Medica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Medico Curante:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneMedica.medicoCurante }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneMedica.medicoCurante" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Esenzione ticket:</label>
                            <span v-if="isReadOnly">{{ jsonDataSituazioneMedica.esenzioneTicket }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneMedica.esenzioneTicket" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataSituazioneMedica.id" @click="onSaveSituazioneMedica"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataSituazioneMedica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    medicoCurante: "",
                    esenzioneTicket: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataSituazioneMedica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaSituazioneMedica: "/rsaschedarelazionesanitariasituazionemedica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaSituazioneMedica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaSituazioneMedica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaSituazioneMedicaSuccess, me.resultResponseSchedaRelazioneSanitariaSituazioneMedicaError);
        },

        resultResponseSchedaRelazioneSanitariaSituazioneMedicaSuccess(response) {
            let me = this;
            me.jsonDataSituazioneMedica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaSituazioneMedicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataSituazioneMedica = {
                id: null,
                idAccettazione: this.idAccettazione,
                medicoCurante: "",
                esenzioneTicket: "",
            };
        },

        onSaveSituazioneMedica() {
            let me = this;
            me.jsonDataSituazioneMedica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataSituazioneMedica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaSituazioneMedica, me.jsonDataSituazioneMedica, me.saveSchedaRelazioneSanitariaSituazioneMedicaSuccessResponse, me.saveSchedaRelazioneSanitariaSituazioneMedicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaSituazioneMedicaSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Situazione medica salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaSituazioneMedicaErrorResponse() {
            console.error("Errore nel salvataggio situazione medica :");
        },
    },
};
</script>
